export default __webpack_public_path__ + "static/media/payment_wallet_icon_active.b90dfcd3.svg";